'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: ', 'px;\n\n  position: absolute;\n  border-radius: 3px;\n  margin-top: 16px;\n  z-index: 100;\n  background: ', ';\n\n  ', '\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    left: 8.5px;\n    width: 0;\n    height: 0;\n    border: 8px solid transparent;\n    border-color: white white transparent transparent;\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: 1px -1px 1px rgba(0,0,0,0.12);\n  }\n'], ['\n  width: ', 'px;\n\n  position: absolute;\n  border-radius: 3px;\n  margin-top: 16px;\n  z-index: 100;\n  background: ', ';\n\n  ', '\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    left: 8.5px;\n    width: 0;\n    height: 0;\n    border: 8px solid transparent;\n    border-color: white white transparent transparent;\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: 1px -1px 1px rgba(0,0,0,0.12);\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _fuse = require('fuse.js');

var _fuse2 = _interopRequireDefault(_fuse);

var _IconList = require('../IconList');

var _IconList2 = _interopRequireDefault(_IconList);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _mixins = require('../../styles/mixins');

var _mixins2 = _interopRequireDefault(_mixins);

var _variables = require('../../styles/variables');

var _variables2 = _interopRequireDefault(_variables);

var _icons = require('../../models/icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.rowLength * props.iconSize + 2 * props.padding;
}, _variables2.default.WHITE, _mixins2.default.BOX_SHADOW);

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover(props) {
    _classCallCheck(this, Popover);

    var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.onSearchChange = function (filter) {
      var fuse = _this.state.fuse;

      // Return everything if filter is empty string

      var filteredIcons = filter === '' ? _this.props.icons : fuse.search(filter);

      _this.setState({
        filter: filter,
        filteredIcons: filteredIcons,
        iconsToRenderCount: _this.minIconsToRender
      });
      _this.scrollRef.scrollToTop();
    };

    _this.onIconClick = function (icon) {
      _this.props.onIconClick(icon);
      _this.clearSearch();
    };

    _this.getContainerHeight = function () {
      return _this.props.iconSize * _this.props.visibleRows + 2 * _variables2.default.PADDING;
    };

    _this.clearSearch = function () {
      _this.setState({
        filter: '',
        filteredIcons: _this.props.icons,
        iconsToRenderCount: _this.minIconsToRender
      });
    };

    _this.handleClickOutside = _this.props.onClickOutside;

    _this.handleScroll = function (values) {
      var scrollTop = values.scrollTop;
      var _this$state = _this.state,
          iconsToRenderCount = _this$state.iconsToRenderCount,
          filteredIcons = _this$state.filteredIcons;


      if (iconsToRenderCount >= filteredIcons.length) {
        return;
      }

      var renderedRows = Math.max(iconsToRenderCount / _this.props.rowLength);
      var renderedHeight = _this.props.iconSize * renderedRows;
      var containerHeight = _this.getContainerHeight();
      var offset = renderedHeight - containerHeight;

      if (scrollTop > offset) {
        _this.setState({
          iconsToRenderCount: iconsToRenderCount + _this.iconRenderBatch
        });
      }
    };

    var minIconsToRender = props.rowLength * (props.visibleRows + 2);

    _this.minIconsToRender = minIconsToRender;
    _this.iconRenderBatch = props.rowLength * 5;

    _this.state = {
      filter: '',
      filteredIcons: props.icons,
      fuse: new _fuse2.default(props.icons, {
        keys: ['name'],
        threshold: 0.4
      }),
      iconsToRenderCount: minIconsToRender
    };
    return _this;
  }

  _createClass(Popover, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          filter = _state.filter,
          filteredIcons = _state.filteredIcons,
          iconsToRenderCount = _state.iconsToRenderCount;


      var containerHeight = this.getContainerHeight();

      var icons = filteredIcons.slice(0, iconsToRenderCount);

      return _react2.default.createElement(
        Container,
        {
          rowLength: this.props.rowLength,
          iconSize: this.props.iconSize,
          padding: _variables2.default.PADDING
        },
        _react2.default.createElement(_Input2.default, {
          onChange: this.onSearchChange,
          value: filter
        }),
        _react2.default.createElement(
          _reactCustomScrollbars.Scrollbars,
          {
            style: {
              height: containerHeight
            },
            onUpdate: this.handleScroll,
            ref: function ref(node) {
              _this2.scrollRef = node;
            },
            autoHide: true,
            hideTracksWhenNotNeeded: true
          },
          _react2.default.createElement(_IconList2.default, {
            icons: icons,
            iconSize: this.props.iconSize,
            onIconClick: this.onIconClick,
            height: Math.max(filteredIcons.length / this.props.rowLength) * this.props.iconSize
          })
        )
      );
    }
  }]);

  return Popover;
}(_react.Component);

Popover.propTypes = {
  onClickOutside: _propTypes2.default.func,
  onIconClick: _propTypes2.default.func,
  icons: _icons2.default,
  rowLength: _propTypes2.default.number.isRequired,
  visibleRows: _propTypes2.default.number.isRequired,
  iconSize: _propTypes2.default.number.isRequired
};
Popover.defaultProps = {
  onClickOutside: function onClickOutside() {},
  onIconClick: function onIconClick() {},
  icons: []
};
exports.default = (0, _reactOnclickoutside2.default)(Popover);